import { Env, ProjectName } from './constants';
import { getProjectDomain } from './getProjectDomain';

export const getOnboardingUrl = (env: Env) =>
  getProjectDomain(ProjectName.Onboarding, env) as string;

export const getNewProductUrl = (env: Env) =>
  `${getOnboardingUrl(env)}new-product`;
